// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".projects-info-item[data-v-a85b3e36]{margin:15px 0}.info-icons[data-v-a85b3e36],.projects-info-item[data-v-a85b3e36] .info-icons{color:#677188;position:relative;right:5px}", ""]);
// Exports
module.exports = exports;
